import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-oeuvres-art-bijoux',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-oeuvres-art-bijoux.component.html',
  styleUrls: ['./assurance-oeuvres-art-bijoux.component.scss']
})
export class AssuranceOeuvresArtBijouxComponent {
  title = 'Assurance Œuvres d\'Art - Bijoux';
  subtitle = '';
  heroImage = 'assets/static_pages_images/monalisa.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Œuvres d\'Art', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Protection Juridique',
    link: '/assurance-protection-juridique'
  };

  nextPage = { 
    title: 'Assurance Dommages-Ouvrage',
    link: '/assurance-dommages-ouvrage'
  };

  constructor(private router: Router) {}
}
